<template>
    <q-page padding class="perfil-page">
        <!-- Header -->
        <div class="page-header q-mb-lg">
            <div class="row items-center no-wrap">
                <q-avatar size="64px" class="header-avatar">
                    <img :src="`https://api.dicebear.com/9.x/identicon/svg?seed=${user?.name}`" alt="Avatar" />
                </q-avatar>
                <div class="col q-ml-md">
                    <div class="text-h5 text-weight-bold text-grey-9">Mi Perfil</div>
                    <div class="text-subtitle2 text-grey-6">{{ user?.name }}</div>
                    <div class="text-caption text-grey-5">{{ user?.email }}</div>
                </div>
            </div>
        </div>

        <!-- Password Change Card -->
        <q-card class="form-card" flat bordered>
            <q-card-section class="card-header">
                <div class="row items-center no-wrap gap-sm">
                    <q-icon name="lock" size="24px" color="white" />
                    <div>
                        <div class="text-subtitle1 text-white text-weight-bold">Cambiar Contraseña</div>
                        <div class="text-caption" style="color: rgba(255,255,255,0.75)">Actualiza tu contraseña de acceso</div>
                    </div>
                </div>
            </q-card-section>

            <q-separator />

            <q-card-section class="q-pa-lg">
                <div class="row q-col-gutter-md">
                    <div class="col-12">
                        <GltnInput
                            v-model="form.current_password"
                            label="Contraseña actual"
                            type="password"
                            @update:model-value="validate('current_password')"
                            :errors="res.getErrors('current_password')"
                        />
                    </div>
                    <div class="col-12 col-md-6">
                        <GltnInput
                            v-model="form.password"
                            label="Nueva contraseña"
                            type="password"
                            @update:model-value="validate('password')"
                            :errors="res.getErrors('password')"
                        />
                    </div>
                    <div class="col-12 col-md-6">
                        <GltnInput
                            v-model="form.password_confirmation"
                            label="Confirmar nueva contraseña"
                            type="password"
                            @update:model-value="validate('password_confirmation')"
                            :errors="res.getErrors('password_confirmation')"
                        />
                    </div>
                </div>
            </q-card-section>

            <q-separator />

            <q-card-actions class="q-pa-md">
                <q-btn
                    unelevated
                    label="Guardar contraseña"
                    color="primary"
                    icon="save"
                    :disable="!res.valid"
                    :loading="loading"
                    @click="savePassword"
                    no-caps
                />
            </q-card-actions>

            <q-inner-loading :showing="loading">
                <q-spinner-hourglass size="50px" color="primary" />
            </q-inner-loading>
        </q-card>
    </q-page>
</template>

<script setup>
import { reactive, ref, computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { useQuasar } from 'quasar';
import GltnInput from '@/components/form/GltnInput.vue';
import ProfileService from '@/services/ProfileService';
import suite from './Perfil/PerfilValidation';

const $q = useQuasar();
const page = usePage();

const user = computed(() => page.props?.auth?.user);
const loading = ref(false);
const res = ref(suite.get());

const form = reactive({
    current_password: '',
    password: '',
    password_confirmation: '',
});

const validate = (field) => {
    res.value = suite(field, form);
};

const savePassword = async () => {
    if (!res.value.valid) return;
    loading.value = true;
    try {
        await ProfileService.updatePassword(form);
        form.current_password = '';
        form.password = '';
        form.password_confirmation = '';
        res.value = suite.get();
    } catch (error) {
        const bagErrors = error?.response?.data?.errors?.updatePassword;
        if (bagErrors?.current_password) {
            $q.notify({ type: 'negative', message: bagErrors.current_password[0] });
        }
    } finally {
        loading.value = false;
    }
};
</script>

<style lang="scss" scoped>
.perfil-page {
    max-width: 700px;
    margin: 0 auto;
}

.header-avatar {
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.25);
}

.form-card {
    border-radius: 12px;
    overflow: hidden;

    .card-header {
        background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
        padding: 20px 24px;
    }
}
</style>
